import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from 'components/Link';

export const Paper = styled(Box)(({ theme }) => ({
  margin: theme.spacing(3, 0),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

export const Typo = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  width: '100%',
  textTransform: 'uppercase'
}));

export const NavLinkActive = styled('h3')(({ theme }) => ({
  margin: 0,
  color: 'white',
  cursor: 'pointer',
  display: 'inline-block',
  borderBottom: '1px solid #ccc',
  paddingBottom: 16
}));

export const LockLinkActive = styled('h3')(({ theme }) => ({
  margin: 0,
  color: 'white',
  cursor: 'pointer',
  paddingBottom: 16,
  borderBottom: '1px solid #ccc',
  fontWeight: 'bold',
  fontSize: 20,
  lineHeight: 1.2
}));

export const InputWrapper = styled('div')(() => ({
  width: '100%',
  '& .MuiInputBase-root': { background: 'white' },
  '& .MuiFormHelperText-root.Mui-error': { color: 'white !important' },
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    border: '1px solid white'
  }
}));

export const ErrorWrapper = styled('div')(() => ({
  '& .MuiFormHelperText-root.Mui-error': { color: 'white !important' }
}));

export const Bold = styled('span')(() => ({ fontWeight: 'bold !important' }));

export const FormFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(2),
  width: '100%'
}));

export const BackLink = styled(Link)`
  &::before {
    content: '› ';
  }
`;

export const Warning = styled('div')(({ theme }) => ({
  color: 'white',
  fontSize: theme.fontSize.small,
  marginTop: 5,
  '& .MuiFormHelperText-root': {
    color: 'white !important'
  }
}));

export const Text = styled('div')(({ theme, first }) => ({
  fontWeight: theme.fontWeight.bold,
  fontSize: theme.fontSize.small,
  color: 'white',
  paddingTop: first ? 30 : 20,
  textAlign: 'center',
  a: { color: 'white' }
}));

export const LockedContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});
